/*
 * @Author: chenyan
 * @Date: 2017-12-27 14:48:19
 * @Description: clipboard 复制剪贴板
 * @Last Modified by: chenyan
 * @Last Modified time: 2017-12-27 15:43:13
 */

import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

export default {
  name: 'clipboard'
}
